import React, { useState} from 'react';
import { HiEmojiHappy, HiMenuAlt4, HiX} from 'react-icons/hi';
import { BiSolidDownload } from "react-icons/bi";
import { motion } from 'framer-motion';
import Logo from '../../constants/logo';
import { images } from '../../constants';
import './Navbar.scss'
import { BsGithub, BsLinkedin } from 'react-icons/bs'

const menus = ["home", "about", "work", "skills", "contact"]

const Navbar = ({ headerRef, visibleSection }) => {
  const [toggle, setToggle] = useState(false);
  const [active, setActive] = useState("1"); 

  const menuVars = {
    initial: {
      scaleY: 0,
    },
    animate: {
      scaleY: 1,
      transition: {
        duration: 0.5,
        ease: [0.12, 0, 0.39, 0],
      },
    },   
    exit: {
        scaleY: 0,

      },
    }
  

  return (
    <nav className='app__navbar' ref={headerRef} >
        <Logo/>
        {/* * * Menu Desktop * * */}
        <ul className='app__navbar-links'>
        { menus.map((menu, index)=>{
              return (
              <li className={`app__flex p-text`} key={index}  >
                <div className={`${visibleSection === menu ? "active" : ""}`}/>
                <a
                  href={`#${menu}`}
                  onClick={()=>{setActive(index)}} 
                  key={index}  
                  className= {`${visibleSection === menu ? "active" : ""}`}
                >
                  {menu}
                </a>
              </li>)
            })
        }
        </ul>
        <ul className='app__navbar-download'>
          <li className='app__flex p-text'>
            <div/>
            <a href={`${images.cv}`} download>Curriculum <span><BiSolidDownload/></span> </a>
          </li>
        </ul>

        {/* * * Menu Mobile * * */}
        <div className='app__navbar-menu'>
            <HiMenuAlt4 onClick={() => setToggle(true)} />
            {toggle && (
                <motion.div
                    variants={menuVars}
                    initial={{height:0, opacity:0}}
                    animate={{height:"100vh", opacity:1}}
                   
                    exit="initial"
                    /*
                    whileInView={{ x : [300, 0]}}
                    transition={{ duration: 0.45, ease: 'easeOut'}} */
                >
            
                    <HiX onClick={()=> setToggle(false)} />
                  

                    <ul className='app__navbar-links'>
                    {['home', 'about', 'work', 'skills', 'contact'].map((menu)=>(
                        <li key={menu}>
                            <a href={`#${menu}`} onClick={()=> setToggle(false)}>{menu}</a>
                        </li>
                    ))}
                    </ul>
                    <ul className='app__navbar-links'>
                      <li>
                        <a href="https://github.com/paolobang" target='_blank' rel='noreferrer'>
                        <span>
                          <BsGithub />
                        </span>
                        </a>

                        <a href="https://www.linkedin.com/in/rudyhuaman/" target='_blank' rel='noreferrer'>  
                          <span>
                              <BsLinkedin />
                          </span>
                        </a>                        
                      </li>
                  </ul>

                </motion.div>
            )}
        </div>
    </nav>
  )
}
export default Navbar;